import React, { useMemo } from 'react';
import { ReviewQuestionWrapper } from '../shared/ReviewQuestionWrapper';
import { OptionItem } from '../shared/OptionItem';
import { transformChoicesToOptions, normalizeOptionId } from '../shared/reviewUtils';
import { useUserAnswerFromStorage } from '../../../../../hooks/useUserAnswerFromStorage';
import { useNormalizedUserAnswer } from '../../../../../hooks/useNormalizedUserAnswer';

const SingleCorrectAnswerReview = ({ question, userAnswer, correctAnswer, isCorrect, accuracy, explanation = '', recap = '', annotations = [], reportProps = null }) => {
  // Get userAnswer from localStorage
  const userAnswerFromStorage = useUserAnswerFromStorage(question);
  
  // Transform backend data to component format
  const transformedQuestion = useMemo(() => {
    const originalQuestion = question.originalQuestion || question;
    const choices = originalQuestion.choices || question.choices || [];
    const options = transformChoicesToOptions(choices);

    return {
      ...question,
      options: options,
      text: originalQuestion.text || originalQuestion['text-soal'] || question.text || question['text-soal'] || '',
    };
  }, [question]);

  // Normalize userAnswer using custom hook
  const userAnswerId = useNormalizedUserAnswer(userAnswer, userAnswerFromStorage, transformedQuestion.options);
  
  // Determine correct answer ID
  const correctOptionId = transformedQuestion.options.find(opt => opt.isCorrect)?.id;

  return (
    <ReviewQuestionWrapper
      questionType="Single Correct Answer"
      question={question}
      explanation={explanation}
      recap={recap}
      annotations={annotations}
      reportProps={reportProps}
    >
      <div
        className="text-base text-[var(--text-primary)] leading-relaxed"
        dangerouslySetInnerHTML={{ __html: transformedQuestion.text }}
      />

      <div className="flex flex-col gap-3">
        {transformedQuestion.options.map((option) => {
          const optionId = normalizeOptionId(option.id);
          const numUserAnswerId = userAnswerId !== null ? normalizeOptionId(userAnswerId) : null;
          const numCorrectOptionId = correctOptionId !== null ? normalizeOptionId(correctOptionId) : null;
          
          const isUserSelected = numUserAnswerId !== null && optionId === numUserAnswerId;
          const isCorrectOption = numCorrectOptionId !== null && optionId === numCorrectOptionId;
          
          // Show correct answer if user answered wrong
          const userAnsweredWrong = numUserAnswerId !== null && numCorrectOptionId !== null && numUserAnswerId !== numCorrectOptionId;
          const showOnlyUserAnswer = !userAnsweredWrong;

          return (
            <OptionItem
              key={option.id}
              option={option}
              isUserSelected={isUserSelected}
              isCorrectOption={isCorrectOption}
              showOnlyUserAnswer={showOnlyUserAnswer}
            />
          );
        })}
      </div>
    </ReviewQuestionWrapper>
  );
};

export default SingleCorrectAnswerReview;

